import React, { useEffect, useState } from 'react';
import axios from 'axios';
import get from 'lodash/get';
import SubscriptionsDetails from '../shared/subscriptionsDetails';
import {
	useApplicationState,
	showErrorModal,
	updateCurrentProjectDetails,
	updateOrgNameInProjectDetailSubscriptions,
	setLoadings,
	updateCurrentProjectDevSubscriptions,
	updateCurrentProjectProdSubscriptions,
	setSubscriptionLoadings
} from '../../utilities/applicationState';
import './subscriptions.scss';

export default function Subscriptions({ projectDetail, type }) {
	const { _id: projectId, consentURLPendingEmail } = projectDetail;
	const [, dispatch] = useApplicationState();
	const [cancelableRequest, setCancelableRequest] = useState(false);

	useEffect(() => {
		if (projectId) {
			getCarDetails();
			dispatch(setLoadings({ loadingProjectInfo: false }));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [projectId])

	//cleanup projectCarDetails
	useEffect(() => {
		return () => {
			dispatch(updateCurrentProjectDetails({ projectCarDetails: {} }));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const onSubscriptionDetailsChange = (opts = {}) => {
		const { search, subscriptions, consents, projectType, type } = opts;
		getCarDetails({ search, subscriptions, consents, projectType, type });
	};

	const getCarDetails = async (opts = {}) => {
		try {
			if (opts.type) {
				let obj = {};
				obj[opts.type] = true;
				dispatch(setSubscriptionLoadings({ isLoadingSubscriptions: obj }));
			} else {
				dispatch(updateCurrentProjectDetails({ projectCarDetails: {} }));
				dispatch(setLoadings({ isLoadingCarDetails: true }));
			}
			const params = {
				removeOwnSubs: true,
				projectType: opts.projectType,
				...(opts.search && { search: opts.search }),
				...(opts.subscriptions && { subscriptions: opts.subscriptions.map(item => item.value) || [] }),
				...(opts.consents && { consents: opts.consents }),
				type: opts.type || 'all'
			};
			const { data } = await axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/project/car-app-details/${projectId}`, {
				params,
				cancelToken: getCancelableRequestToken().token
			});
			if (opts.type) {
				if (opts.projectType === 'PROD') {
					dispatch(updateCurrentProjectProdSubscriptions({ ...data.prod.subscriptions }));
				} else {
					dispatch(updateCurrentProjectDevSubscriptions({ ...data.subscriptions }));
				}
				dispatch(setSubscriptionLoadings({ isLoadingSubscriptions: {} }));
			} else {
				dispatch(updateCurrentProjectDetails({ projectCarDetails: { ...data } }));
				dispatch(setLoadings({ isLoadingCarDetails: false }));
			}
		} catch (e) {
			if (e && e.message !== 'search request canceled') {
				dispatch(showErrorModal(get(e, 'response.data.message', 'Something went wrong when trying to get Project List. Please try again.')));
			}
		}
	}

	const retrieveOrgName = async (ooid = '', type) => {
		let name = 'Loading...';
		dispatch(updateOrgNameInProjectDetailSubscriptions({ ooid, organizationName: name, type }))
		try {
			const { data } = await axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/org-name-cache/${ooid}`);
			name = data.name;
		} catch (e) {
			name = 'Error';
		}
		dispatch(updateOrgNameInProjectDetailSubscriptions({ ooid, organizationName: name, type }))
	}

	const getCancelableRequestToken = () => {
		if (cancelableRequest) {
			cancelableRequest.cancel('search request canceled');
		}
		const newRequest = axios.CancelToken.source();
		setCancelableRequest(newRequest);
		return newRequest;
	};

	return (
		<SubscriptionsDetails {...{
			isFromProjects: true,
			retrieveOrgName,
			onSubscriptionDetailsChange,
			projectType: type,
			projectId,
			prodProjectId: type === 'PROD' ? projectId : '',
			consentURLPendingEmail
		}} />
	)
};
